import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { apiFetch, apiUploadFile } from "@/lib/api";
import type {
  DocCategoria,
  Documento,
  DocumentoUpdate,
  DocVisibilita,
} from "@/types/api";

export function useAdminDocumenti() {
  return useQuery({
    queryKey: ["admin-documenti"],
    queryFn: () => apiFetch<Documento[]>("/api/v1/admin/documenti"),
    staleTime: 30_000,
  });
}

export interface UploadDocumentoArgs {
  file: File;
  categoria: DocCategoria;
  nome: string;
  descrizione?: string;
  visibilita: DocVisibilita;
}

export function useUploadDocumento() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      file,
      categoria,
      nome,
      descrizione,
      visibilita,
    }: UploadDocumentoArgs) => {
      const form = new FormData();
      form.append("file", file);
      form.append("categoria", categoria);
      form.append("nome", nome);
      form.append("visibilita", visibilita);
      if (descrizione) form.append("descrizione", descrizione);
      return apiUploadFile<Documento>("/api/v1/admin/documenti/upload", form);
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["admin-documenti"] });
      qc.invalidateQueries({ queryKey: ["documenti"] });
    },
  });
}

interface UpdateArgs {
  id: string;
  body: DocumentoUpdate;
}

export function useUpdateDocumento() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: UpdateArgs) =>
      apiFetch<Documento>(`/api/v1/admin/documenti/${id}`, {
        method: "PATCH",
        body: JSON.stringify(body),
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["admin-documenti"] });
      qc.invalidateQueries({ queryKey: ["documenti"] });
    },
  });
}

export function useEliminaDocumento() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) =>
      apiFetch<void>(`/api/v1/admin/documenti/${id}`, { method: "DELETE" }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["admin-documenti"] });
      qc.invalidateQueries({ queryKey: ["documenti"] });
    },
  });
}
